/*
 * @Author: Teemo Ding
 * @Date: 2021-07-12 16:52:54
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-07-12 17:00:24
 * @FilePath: /unifyxp-v2-store-portal/src/request/settings/order/index.ts
 */
import { get, post } from 'src/tools/server';

export const getOrder = () => {
  return get<any>(`/portal/setting/order`, {});
};

export const saveOrder = (body) => {
  return post<any>(`/portal/setting/order`, body, {});
};
